/**
 * عميل API — النقطة الوحيدة التي يتحدث منها الـFrontend إلى الخادم.
 *
 * الواجهة لا تعرف المصدر الرسمي ولا تتصل به. كل شيء يمر عبر `/api`.
 */

const BASE = import.meta.env.VITE_API_BASE_URL ?? '/api';
const TOKEN_KEY = 'nitaq.session';

export function getToken(): string | null {
  try {
    return window.localStorage.getItem(TOKEN_KEY);
  } catch {
    return null;
  }
}

export function setToken(token: string | null): void {
  try {
    if (token) window.localStorage.setItem(TOKEN_KEY, token);
    else window.localStorage.removeItem(TOKEN_KEY);
  } catch {
    /* التخزين غير متاح — الجلسة تبقى للصفحة الحالية فقط */
  }
}

export class ApiError extends Error {
  constructor(
    readonly status: number,
    readonly code: string,
    message: string,
  ) {
    super(message);
    this.name = 'ApiError';
  }
}

export async function api<T>(
  path: string,
  options: { method?: string; body?: unknown; auth?: boolean } = {},
): Promise<T> {
  const headers: Record<string, string> = {};
  if (options.body !== undefined) headers['content-type'] = 'application/json';
  if (options.auth !== false) {
    const token = getToken();
    if (token) headers.authorization = `Bearer ${token}`;
  }

  let res: Response;
  try {
    res = await fetch(`${BASE}${path}`, {
      method: options.method ?? 'GET',
      headers,
      body: options.body === undefined ? undefined : JSON.stringify(options.body),
    });
  } catch {
    throw new ApiError(0, 'network', 'تعذّر الوصول إلى الخادم.');
  }

  const text = await res.text();
  const parsed = text ? (JSON.parse(text) as Record<string, unknown>) : {};

  if (!res.ok) {
    const error = parsed.error as { code?: string; message?: string } | undefined;
    throw new ApiError(res.status, error?.code ?? 'error', error?.message ?? 'حدث خطأ.');
  }
  return parsed as T;
}
